
// Compile our scss
// This 'includes' the SCSS index file which webpack then reads and
// compiles into the necessary css files
require('../scss/index.scss');

// Bring in font-awesome via npm
require('../../node_modules/@fortawesome/fontawesome-free/js/all.js');

// Inject our components
require('./components/effects.js');
require('./components/slider.js');